export default {

  /**
   * 平台名称
   */
  systemName: '源点CRM系统',
  /**
   * 公司
   */
  company: '源点集团',
  /**
   * 企业微信的CorpID
   */
  appId: 'wwe0f0767707cac526',
  /**
   * 授权方的网页应用ID
   */
  agentId: '1000010',
   /**
   * 备案号
   */
   recordNumber: '豫ICP备2025112036号-1',
  /**
   * 扫码登陆重定向
   */
  scanRedirectUrl: {
    dev: 'http://l0sq4zb1.dnat.tech',
    pro: 'http://www.maizhihui.cn'
  },
  /**
   * @description 配置显示在浏览器标签的title
   */
  title: 'CRM管理系统',
  /**
   * @description api请求基础路径
   */
  baseUrl: {
    dev: 'http://127.0.0.1:8081/api',
    pro: 'http://www.maizhihui.cn/api'
  },
  /**
   * @description ws请求基础路径
   */
  wsUrl: {
    dev: '',
    pro: ''
  },
  /**
   * 输入框样式
   */
  inputStyle: {
    dense: 'filled rounded single-line dese',
    default: 'filled rounded single-line',
    clearIcon: 'mdi-close-circle-outline',
  },
  /**
   * @description 默认打开的首页的路由name值，默认为home
   */
  homeName: 'Dashboard',
  /**
   * @description 默认打开的首页的路由name值，默认为home(移动端)
   */
   mHomeName: 'Dashboard',
  /**
   * @description 扫码登陆页面
   */
  loginName: 'Login',
  /**
   * @description 应用内面登陆授权页面
   */
  authName: 'Auth',
 /**
   * @description 账号密码登陆
   */
  webLoginName: 'WebLogin',
  /**
   * @description 账号密码登陆(移动端)
   */
   mobileLoginName: 'MobileLogin',
  /**
   * 入职登记页
   */
  inductionName: 'Induction',
  /**
   * 阿里云
   */
  oss: {
    region: 'oss-cn-zhangjiakou',
    accessKeyId: 'LTAI5tJU51HVeapQWA5vwC6V',
    accessKeySecret: 'yb6jC93Bxiz65oNJusp062QZC2Omkw'
  }
}
